import { render, staticRenderFns } from "./empty-data.vue?vue&type=template&id=420fcc36&scoped=true"
import script from "./empty-data.vue?vue&type=script&lang=js"
export * from "./empty-data.vue?vue&type=script&lang=js"
import style0 from "./empty-data.vue?vue&type=style&index=0&id=420fcc36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420fcc36",
  null
  
)

export default component.exports